import type { ReactNode } from 'react';
import { DialogProvider } from './DialogProvider';
import { SettingsModalProvider } from './SettingsModalProvider';
import { UpgradeModalProvider } from './UpgradeModalProvider';
import { ProtectedAppProvidersShared } from './ProtectedAppProviders.shared';

export default function ProtectedAppProvidersWeb({
  children,
}: {
  children: ReactNode;
}) {
  return (
    <ProtectedAppProvidersShared>
      <DialogProvider>
        <SettingsModalProvider>
          <UpgradeModalProvider>{children}</UpgradeModalProvider>
        </SettingsModalProvider>
      </DialogProvider>
    </ProtectedAppProvidersShared>
  );
}
